'use strict';

angular.module('shiftTraderApp')
  .service('NotesQueryManagementService', ['uuid4', 'NotesStore', 'TimeService',
    function(uuid4, NotesStore, TimeService) {
      var state = {};

      NotesStore.getRxSubject().subscribe(function(note) {
        lodash.forOwn(state, function(dikt) {
          if (dikt && dikt.query) {
            dikt.subject.onNext({note: note});
          }
        });
      });

      function setQueryForId(uuid, query) {
        if (state[uuid]) {
          state[uuid].query = query;
        } else {
          state[uuid] = {
            subject: new Rx.Subject(),
            query: query
          };
        }

        state[uuid].subject.onNext({queryUpdate: state[uuid].query});
      }

      function getIdState(uuid) {
        if (!state[uuid]) {
          state[uuid] = {
            subject: new Rx.Subject()
          };
        }

        if (!state[uuid].query) {
          var dates = TimeService.getDayTwixFromDate(TimeService.getNowInStoreTime());
          state[uuid].query = {
            obj: 'date',
            obj_id: null,
            dates: {
              start: dates.start,
              end: dates.end
            }
          };
        }

        return state[uuid];
      }

      function removeId(uuid) {
        state[uuid] = undefined
      }

      function getIdForName(name) {
        var theId;

        lodash.forOwn(state, function(dikt, key) {
          if (dikt.name === name) {
            theId = key;
            return false;
          }
        });

        return theId;
      }

      function registerQueryChange(uuid, newQuery) {
        console.log('***** Query Change', uuid, newQuery);
        setQueryForId(uuid, newQuery);
        return getIdState(uuid);
      }

      function registerQueryChangeFromContext(uuid, newContext) {
        return registerQueryChange(uuid, newContext);
      }

      function genFilter(uuid) {

        return function(obj) {
          var idState = getIdState(uuid);
          if (obj.note) {
            var range_twix;
            var result;

            if (idState.query.dates && idState.query.dates.start && !idState.query.dates.end) {
              range_twix = moment(idState.query.dates.start).twix(moment().add(30, 'years'));

            } else if (idState.query.dates && idState.query.dates.start && idState.query.dates.end) {
              range_twix = moment(idState.query.dates.start).twix(moment(idState.query.dates.end));
            } else {

            }

            return lodash.some(obj.note.notes_relations, function(nr) {
              result = true;

              if (range_twix) {
                if (nr.range_twix) {
                  if (nr.start_date.isSame(nr.end_date, 'second')) {
                    result = result && range_twix.contains(nr.start_date);
                  } else {
                    result = result && nr.range_twix.overlaps(range_twix) &&
                      Math.abs(nr.range_twix.intersection(range_twix).length('minutes')) > 0;
                  }
                }
              }

              // check for obj and obj_id if in query
              if (idState.query.obj && idState.query.obj_id) {
                result = result && nr.obj && nr.obj_id;
              }
              return result;
            });
          } else if (obj.queryUpdate) {
            return true;
          }
        };
      }

      function getUniqueId(name) {
        var anExistingIdForName = getIdForName(name);

        if (anExistingIdForName) {
          return anExistingIdForName;
        } else {
          var uuid = uuid4.generate();

          state[uuid] = {
            subject: new Rx.Subject(),
            name: name
          };

          return uuid;
        }
      }

      return {
        getUniqueId: getUniqueId,
        getIdState: getIdState,
        registerQueryChange: registerQueryChange,
        registerQueryChangeFromContext: registerQueryChangeFromContext,
        genFilter: genFilter,
        removeId: removeId,
        getIdForName: getIdForName
      };

    }]);
